var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsiconhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_33047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#909090",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 14.5C24.8096 14.4165 24.7744 14.3374 24.7142 14.2794L21.8438 11.696V7.96875C21.8411 7.89057 21.8102 7.81601 21.7568 7.75886L19.0849 5.08698C19.0273 5.03427 18.953 5.00348 18.875 5H10.2656C10.1869 5 10.1114 5.03128 10.0557 5.08695C10 5.14263 9.96875 5.21814 9.96875 5.29688V11.696L7.09827 14.2788C7.03803 14.337 7.00279 14.4163 7 14.5V23.7031C7.001 23.7815 7.0326 23.8565 7.08806 23.9119C7.14352 23.9674 7.21845 23.999 7.29688 24H24.5156C24.5941 23.9992 24.6691 23.9676 24.7246 23.9121C24.7801 23.8566 24.8117 23.7816 24.8125 23.7031V14.5ZM24.2188 15.0813V23.0375L19.309 18.6364L24.2188 15.0813ZM24.0439 14.4748L21.8438 16.0678V12.4946L24.0439 14.4748ZM18.5781 5.59375V7.96875C18.5781 8.04749 18.6094 8.123 18.6651 8.17867C18.7208 8.23435 18.7963 8.26562 18.875 8.26562H21.25V16.4977L18.8566 18.2305L16.1046 15.7632C16.0501 15.7143 15.9795 15.6873 15.9062 15.6873C15.833 15.6873 15.7624 15.7143 15.7079 15.7632L12.9559 18.2305L10.5625 16.4977V5.59375H18.5781ZM7.59375 15.0813L12.5035 18.6364L7.59375 23.0381V15.0813ZM9.96875 16.0678L7.76861 14.4748L9.96875 12.4946V16.0678ZM8.07261 23.4062C11.9899 19.8942 13.8851 18.1955 15.9062 16.3831L23.7399 23.4062H8.07261Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 0.558824
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9H16",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11.5H16H19.5V10.5H16H12.5V11.5Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 13.5H16H19.5V12.5H16H12.5V13.5Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_33047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsiconhover);
export default __webpack_public_path__ + "static/media/formsiconhover.0fd8c0e0.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsiconhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_33047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#909090",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 14.5C24.8096 14.4165 24.7744 14.3374 24.7142 14.2794L21.8438 11.696V7.96875C21.8411 7.89057 21.8102 7.81601 21.7568 7.75886L19.0849 5.08698C19.0273 5.03427 18.953 5.00348 18.875 5H10.2656C10.1869 5 10.1114 5.03128 10.0557 5.08695C10 5.14263 9.96875 5.21814 9.96875 5.29688V11.696L7.09827 14.2788C7.03803 14.337 7.00279 14.4163 7 14.5V23.7031C7.001 23.7815 7.0326 23.8565 7.08806 23.9119C7.14352 23.9674 7.21845 23.999 7.29688 24H24.5156C24.5941 23.9992 24.6691 23.9676 24.7246 23.9121C24.7801 23.8566 24.8117 23.7816 24.8125 23.7031V14.5ZM24.2188 15.0813V23.0375L19.309 18.6364L24.2188 15.0813ZM24.0439 14.4748L21.8438 16.0678V12.4946L24.0439 14.4748ZM18.5781 5.59375V7.96875C18.5781 8.04749 18.6094 8.123 18.6651 8.17867C18.7208 8.23435 18.7963 8.26562 18.875 8.26562H21.25V16.4977L18.8566 18.2305L16.1046 15.7632C16.0501 15.7143 15.9795 15.6873 15.9062 15.6873C15.833 15.6873 15.7624 15.7143 15.7079 15.7632L12.9559 18.2305L10.5625 16.4977V5.59375H18.5781ZM7.59375 15.0813L12.5035 18.6364L7.59375 23.0381V15.0813ZM9.96875 16.0678L7.76861 14.4748L9.96875 12.4946V16.0678ZM8.07261 23.4062C11.9899 19.8942 13.8851 18.1955 15.9062 16.3831L23.7399 23.4062H8.07261Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 0.558824
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9H16",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11.5H16H19.5V10.5H16H12.5V11.5Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 13.5H16H19.5V12.5H16H12.5V13.5Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_33047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsiconhover);
export default __webpack_public_path__ + "static/media/formsiconhover.0fd8c0e0.svg";
export { ForwardRef as ReactComponent };